export class ApiError extends Error {
  readonly code: string;
  readonly status: number;
  readonly fields: Record<string, string>;

  constructor(
    status: number,
    payload: {
      error?: {
        code?: string;
        message?: string;
        fields?: Record<string, string>;
      };
    },
  ) {
    super(payload.error?.message ?? '请求失败');
    this.name = 'ApiError';
    this.code = payload.error?.code ?? 'REQUEST_FAILED';
    this.status = status;
    this.fields = payload.error?.fields ?? {};
  }
}

export async function apiRequest<T>(
  path: string,
  init: RequestInit = {},
): Promise<T> {
  const response = await fetch(`/api${path}`, {
    ...init,
    credentials: 'same-origin',
    headers: {
      ...(init.body ? { 'Content-Type': 'application/json' } : {}),
      ...init.headers,
    },
  });
  if (response.status === 204) return undefined as T;
  const payload: unknown = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new ApiError(
      response.status,
      payload && typeof payload === 'object' ? payload : {},
    );
  }
  return payload as T;
}

export function recordExportUrl(
  taskId: number,
  filters: Record<string, string | undefined>,
): string {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value) params.set(key, value);
  });
  const query = params.toString();
  return `/api/tasks/${String(taskId)}/records.csv${query ? `?${query}` : ''}`;
}
